import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { PageLoader } from '@customerio/pluma-components/react';

const NewsletterReportsPage = lazy(
  () => import('@/pages/workspaces/broadcasts/newsletter/overview/reports/index.page'),
);

function NewsletterReportsRoute() {
  const { newsletterId } = Route.useParams();
  return (
    <Suspense fallback={<PageLoader label="Loading…" />}>
      <NewsletterReportsPage key={newsletterId} newsletterId={newsletterId} />
    </Suspense>
  );
}

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/broadcasts_/newsletter/$newsletterId/overview/reports',
)({ component: NewsletterReportsRoute });
